import Vue from 'vue';
import Vuex from 'vuex';
import {SkillStoreModule} from '@/store/skill.store.module';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    getters: {},
    modules: {
        skill: SkillStoreModule,
    },
});

export default store;
